import QRCode from 'qrcode';

export const renderQrCode = (canvas: HTMLCanvasElement, text: string): Promise<void> =>
  QRCode.toCanvas(canvas, text, {
    width: 200,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#0b0f2a', light: '#f3f4ff' },
  });
